import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  useSysDataUpdateWhitelistMutation,
  useSysDataWhitelistQuery,
} from "@/api/hooks/sys-data-hooks";

const WhitelistConfigTable = ({ room }: { room: string }) => {
  const { t } = useTranslation();
  const {
    data: whitelistValues,
    isLoading: whitelistIsLoading,
    refetch,
  } = useSysDataWhitelistQuery({
    domain: room,
  });

  const updateWhitelist = useSysDataUpdateWhitelistMutation(
    { domain: room },
    {
      onSuccess: () => {
        enqueueSnackbar(t("configSaved"), { variant: "success" });
        //queryClient.invalidateQueries([`/sys-data/my-domain/whitelist`]);
      },
    }
  );

  /*const cfgPerm = useCfgPerm({
    roomName: room,
    cfgName: ROOM_CONFIGS_NAMES.WHITELIST,
  });*/

  const [text, setText] = useState("");

  useEffect(() => {
    if (whitelistValues?.data) {
      setText(Array.from(whitelistValues.data).join("\n"));
    }
  }, [whitelistValues]);

  const handleSave = () => {
    const lines = text
      .split("\n")
      .map((s) => s.trim())
      .filter(Boolean); // убирает пустые строки
    updateWhitelist.mutate(new Set(lines)); // возвращаем массив строк
  };

  return (
    <Stack spacing={2}>
      {whitelistIsLoading ? (
        <CircularProgress size={20} />
      ) : (
        <TextField
          label="Whitelist"
          multiline
          minRows={8}
          value={text}
          onChange={(e) => setText(e.target.value)}
          fullWidth
        />
      )}

      <Button variant="contained" onClick={handleSave}>
        Save
      </Button>
    </Stack>
  );
};

export default WhitelistConfigTable;
